/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { target } from 'react-aim';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@getgrover/ui';
import { sendAnalyticsEvent } from '@devsbb/analytics-client';

import { PureTranslator } from 'ggApp/modules/translator';

import Item from './Item';
import { Wrap, Background, ViewAllLink } from './styled';

@target()
class SubCategoryList extends React.PureComponent {
    clickHandler = (event) => {
        const { closeMenu, storeActive } = this.props;
        const analyticsValue = event?.currentTarget?.href;
        sendAnalyticsEvent('Category Clicked', {
            store_id: storeActive.store_id,
            value: analyticsValue,
        });

        if (window.event?.metaKey || window.event?.ctrlKey) return;
        closeMenu();
    };

    renderItem = (item) => {
        const { id } = item;
        const { isHidden } = this.props;
        return (
            <Item
                key={id}
                onClick={this.clickHandler}
                showIconBackground={!isHidden}
                subcategory={item}
            />
        );
    };

    render() {
        const { subCategories, parentCategoryPermalink, isHidden } = this.props;
        return (
            <Wrap isHidden={isHidden}>
                <Background />
                {subCategories.map(this.renderItem)}
                <ViewAllLink
                    external={false}
                    url={parentCategoryPermalink}
                    onClick={this.clickHandler}
                    type="catalog-link"
                >
                    <ButtonV2 small color="black">
                        <PureTranslator tk="CATEGORY_MENU_VIEW_ALL" />
                    </ButtonV2>
                </ViewAllLink>
            </Wrap>
        );
    }
}

SubCategoryList.propTypes = {
    subCategories: PropTypes.arrayOf(PropTypes.object),
    isHidden: PropTypes.bool,
    parentCategoryPermalink: PropTypes.string,
    closeMenu: PropTypes.func,
};

SubCategoryList.defaultProps = {
    subCategories: [],
    isHidden: false,
    parentCategoryPermalink: '',
    closeMenu: () => {},
};

export default SubCategoryList;
